import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import tab from './components/TabCtrl'
import menus from './views/menuconfig'
import Cookies from 'js-cookie';
import config from './config/config';
import api from './config/apiConfig';
import axios from 'axios';
import myUtil from './utils/util';

export default new Vuex.Store({
  state: {
	  menus: [], // 菜单列表
  },
  mutations: {
	  // 获取菜单列表
	  // //TODO  将来项目实绩化后删除菜单栏
	  updateMenulist1(state) {
		  state.menus = menus;
	  },
	  // 菜单初始化
	  //TODO  将来项目实绩化后开放出来使用动态菜单栏
	  updateMenulist(state) {
		  var res = [];
		  var roleId = Cookies.get(config.cookies.currRoleId);
		  if (roleId === undefined || roleId === '') {
			  return;
		  }
		  var url = api.menu.role + roleId;
		  var index = -1;
		  // console.log(url,'=12======23==');
		  axios.get(url, {
			  headers: {
				  'Content-Type': 'application/json;charset=UTF-8',
				  'authorization': Cookies.get('slash_token')
			  },
			  timeout: 60000
		  })
			  .then(function (response) {
				  try {
					  var dbList = response.data.data;
					  // console.log(dbList,"===data=====1===");
					  var sortList = dbList.sort(myUtil.compare('sort'));
					  // console.log(sortList,"===data=====2===");
					  // var menuStr = "";
					  var menusObj = {};
					  var res = [];
					  // sortList.forEach(item => {
						//   var p = {
						// 	  // path: '/' + item.menuNameZh,
						// 	  icon: item.menuClass,
						// 	  title: item.menuNameZh,
						// 	  parentId: item.parentId,
						// 	  level: item.menuLevel,
						// 	  routername: item.menuNameEn,
						// 	  // component: resolve => {
						// 		//   require([item.menuNameEn], resolve);
						// 	  // },
						// 	  children: []
						//   };
						//   menusObj[item.id] = p;
					  // });
					  sortList.forEach((item) => {
					      if (item.parentId=== '0' || item.parentId === 0) {
					          var p = {
					              // path: '/' + item.menuNameZh,
					              icon: item.menuClass,
					              title: item.menuNameZh,
								  routername: item.menuNameEn,
					              // component: resolve => {
					              //     require([item.menuNameEn], resolve);
					              // },
					              children: []
					          };
					          index++;
					          res.push(p);
							  // menusObj.push(p);
					      } else {
					          var c = {
					              // path: item.menuNameZh,
					              icon: item.menuClass,
					              title: item.menuNameZh,
								  routername: item.menuNameEn,
					              // component: resolve => {
					              //     require([item.menuNameEn], resolve);
					              // }
					          };
					          res[index].children.push(c);
							  // menusObj[index].children.push(c);
					      }
					      // menuStr = menuStr + item.menuNameEn + ",";
					  });

					  // console.log(res,"===data=====3===");
					  // 遍历菜单对象
					  // for (var menuId in menusObj) {
						//   var menuTemp = menusObj[menuId];
						//   if (menuTemp.parentId !== '0') {
						// 	  if(menusObj[menuTemp.parentId].children){
						// 		  menusObj[menuTemp.parentId].children.push(menuTemp);
						// 	  }else{
						// 		  console.log(menusObj[menuTemp.parentId]);
						// 	  }
						//   }
					  // }
					  // console.log(res,"===data=====3===");
					  // var res = [];
					  // // 生成菜单
					  // for (var menuId in menusObj) {
						//   // if (menusObj[menuId].level == '0') {
						// 	  res.push(menusObj[menuId]);
						//   // }
					  // }

				  } catch (err) {
					  console.log(err);
				  };
				  // sortList.forEach((item, j) => {
				  //     if (item.parentId=== '0' || item.parentId === 0) {
				  //         var p = {
				  //             path: '/' + item.menuNameZh,
				  //             icon: item.menuClass,
				  //             title: item.menuNameZh,
				  //             name: item.menuNameEn,
				  //             component: resolve => {
				  //                 require([item.menuNameEn], resolve);
				  //             },
				  //             children: []
				  //         };
				  //         index++;
				  //         res.push(p);
				  //     } else {
				  //         var c = {
				  //             path: item.menuNameZh,
				  //             icon: item.menuClass,
				  //             title: item.menuNameZh,
				  //             name: item.menuNameEn,
				  //             component: resolve => {
				  //                 require([item.menuNameEn], resolve);
				  //             }
				  //         };
				  //         res[index].children.push(c);
				  //     }
				  //     // menuStr = menuStr + item.menuNameEn + ",";
				  // });
				  res.forEach((menu1,index1)=>{
					  menu1.index=index1.toString();
					  if(menu1.children){
						  menu1.children.forEach((menu2,index2)=>{
							  menu2.index=index1+'.'+index2;
							  if(menu2.children){
								  menu2.children.forEach((menu3,index3)=>{
									  menu3.index=index1+'.'+index2+'.'+index3;
								  })
							  }
						  })
					  }
				  })
				  state.menus = res;
				  // state.menus = JSON.parse(JSON.stringify(state.menus))
				  // console.log(state.menus,"===last menu===");
			  }).catch(function (error) {

		  });
	  },
  },
  actions: {

  },
  modules:{
    tab
  }
})



// WEBPACK FOOTER //
// ./src/store.js